module.exports = __webpack_public_path__ + "static/media/87.eacfa733.jpg";